import { PartnerListPage } from "@/features/partner/pages/PartnerList";

const PartnerList = () => {
  return <PartnerListPage />;
};

export default PartnerList;
